import(/* webpackMode: "eager" */ "/codebuild/output/src3310707133/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/error.tsx");
